// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4104) return "static/chunks/4104.9c57aa91593b7b53.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"3174":"92a7afac597b91d8","7522":"83771028b6502f51"}[chunkId] + ".js";
};